import Sortable from "sortablejs";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    submitOnUpdate: Boolean,
  };

  connect() {
    this.sortable =
      Sortable.get(this.element) ||
      Sortable.create(this.element, {
        animation: 150,
        handle: ".sortable",
        forceFallback: true,
        onUpdate: this.onUpdate,
      });
  }

  // Dragging a nested list's ancestor moves it, and Stimulus reports a move as a
  // disconnect. Destroying here would call Sortable's _onDrop mid-drag, stranding
  // the drag ghost on the page and unbinding the pointer handlers.
  disconnect() {
    if (!this.element.isConnected) {
      this.sortable.destroy();
    }
  }

  onUpdate = () => {
    if (this.submitOnUpdateValue) {
      this.element.requestSubmit();
    }
  };
}
